import React from "react";
import "./Reports.css";
import { FaSort, FaSortUp, FaSortDown, FaEye } from "react-icons/fa";

import Pagination from "../../components/Pagination/Pagination";
import {
  formatCurrency,
  formatDate,
  mapStatusToBootstrap,
} from "../../components/Constants/Constants";

import AppLoader from "../../components/AppLoader/appLoader";
import UnAuthorized from "../UnAuthorized/UnAuthorized";
import usePermission from "../../utils/usePermission";
import { useReports } from "../../customHooks/Reports/useReports";
import CopyIcon from "../../components/CopyIcon/CopyIcon";

const Reports = () => {
  const {
    reports,
    loading,
    totalOrderCount,
    filters,
    setFilters,
    handleFilterChange,
    clearFilters,
    sortConfig,
    handleSort,
    paginatedReports,
    totalPages,
    currentPage,
    startItem,
    endItem,
    goToPage,
    itemsPerPage,
    handleItemsPerPageChange,
    filterOptions,
    selectedOption,
    setSelectedOption,
    searchValue,
    setSearchValue,
    handleDropdownChange,
    handleSearchChange,
    searchOptions,
    itemsPerPageOptions,
  } = useReports();

  const canViewReports = usePermission("REPORT_LISTING");

  return (
    <>
      {!canViewReports ? (
        <div>
          {/* {selectedOrders.length > 0 && (
      <div className="d-flex justify-content-end align-items-center mt-2">

        <button
          className="btn btn-primary d-flex align-items-center"
          style={{ padding: "4px 8px", fontSize: "14px" }}
          onClick={sendSettlementRequest}
        >
          Send Settlement Request
        </button>
      </div>
      )} */}

          <div className="filters-wrapper bg-white px-3 py-2 rounded shadow-sm">
            <div className="row gx-4 gy-3 align-items-end flex-wrap">
              <div className="col-auto">
                <label
                  className="form-label mb-1"
                  style={{ fontSize: "0.8rem" }}
                >
                  Search By
                </label>
                <div className="d-flex align-items-center">
                  <select
                    className="form-select"
                    value={selectedOption}
                    onChange={handleDropdownChange}
                    style={{
                      width: "150px",
                      borderTopRightRadius: "0",
                      borderBottomRightRadius: "0",
                    }}
                  >
                    {searchOptions?.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <input
                    type="text"
                    className="form-control"
                    value={searchValue}
                    onChange={handleSearchChange}
                    placeholder={`${selectedOption
                      .split("_")
                      .map(
                        (word) => word.charAt(0).toUpperCase() + word.slice(1)
                      )
                      .join(" ")}`}
                    style={{
                      width: "200px",
                      borderTopLeftRadius: "0",
                      borderBottomLeftRadius: "0",
                    }}
                  />
                </div>
              </div>

              {/* Buyer App */}
              <div className="col-auto">
                <label
                  className="form-label mb-1"
                  style={{ fontSize: "0.8rem" }}
                >
                  Buyer App
                </label>
                <select
                  className="form-select"
                  value={filters.buyer_app_id || ""}
                  onChange={(e) =>
                    handleFilterChange("buyer_app_id", e.target.value)
                  }
                  style={{ minWidth: "150px" }}
                >
                  <option value="">All</option>
                  {filterOptions?.buyerAppIds?.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>

              {/* Seller App */}
              {/* <div className="col-auto">
                <label
                  className="form-label mb-1"
                  style={{ fontSize: "0.8rem" }}
                >
                  Seller App
                </label>
                <select
                  className="form-select"
                  value={filters.seller_app_id || ""}
                  onChange={(e) =>
                    handleFilterChange("seller_app_id", e.target.value)
                  }
                  style={{ minWidth: "150px" }}
                >
                  <option value="">All</option>
                  {filterOptions?.sellerAppIds?.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div> */}

              <div className="col-auto">
                <label
                  className="form-label mb-1.5"
                  style={{ fontSize: "0.8rem" }}
                >
                  Report Created Between
                </label>
                <div className="d-flex flex-wrap gap-3">
                  <div
                    className="position-relative"
                    style={{ minWidth: "130px" }}
                  >
                    <label
                      style={{
                        position: "absolute",
                        top: "-10px",
                        left: "10px",
                        background: "#fff",
                        fontSize: "0.7rem",
                        padding: "0 4px",
                        zIndex: 1,
                        color: "#6c757d",
                      }}
                    >
                      From
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      value={filters.settlement_created_at_from}
                      onChange={(e) =>
                        handleFilterChange(
                          "settlement_created_at_from",
                          e.target.value
                        )
                      }
                    />
                  </div>

                  {/* TO Date */}
                  <div
                    className="position-relative"
                    style={{ minWidth: "130px" }}
                  >
                    <label
                      style={{
                        position: "absolute",
                        top: "-10px",
                        left: "10px",
                        background: "#fff",
                        fontSize: "0.75rem",
                        padding: "0 4px",
                        zIndex: 1,
                        color: "#6c757d",
                      }}
                    >
                      To
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      value={filters.settlement_created_at_to}
                      onChange={(e) =>
                        handleFilterChange(
                          "settlement_created_at_to",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </div>
              </div>

              {/* Clear Filters Button */}
              <div className="col-auto">
                <button
                  type="button"
                  className="clearFilter d-flex align-items-center"
                  onClick={clearFilters}
                >
                  <i className="bi bi-x-circle me-1"></i>
                  Reset Filters
                </button>
              </div>
            </div>
          </div>

          {/* Orders table */}
          {loading ? (
            <AppLoader />
          ) : (
            <>
              <div
                className="table-responsive mt-4"
                style={{ overflowX: "auto" }}
              >
                <table
                  className="table table-bordered table-hover align-middle"
                  style={{ minWidth: "1200px" }}
                >
                  <thead className="table-light">
                    <tr>
                      <th style={{ minWidth: "150px" }}>Reference Txn. ID</th>
                      <th style={{ minWidth: "150px" }}>Reference Msg ID</th>
                      <th style={{ minWidth: "150px" }}>Msg ID</th>
                      <th style={{ minWidth: "150px" }}>Buyer App ID</th>
                      <th style={{ minWidth: "150px" }}>Seller App ID</th>
                      <th style={{ minWidth: "150px" }}>Settlement ID</th>
                      <th style={{ minWidth: "150px" }}>Txn. ID</th>

                      <th
                        style={{ minWidth: "150px" }}
                        onClick={() => handleSort("createdAt")}
                        role="button"
                      >
                        Created At &nbsp;
                        {sortConfig.key === "createdAt" ? (
                          sortConfig.direction === "asc" ? (
                            <FaSortUp size={14} />
                          ) : (
                            <FaSortDown size={14} />
                          )
                        ) : (
                          <FaSort size={14} />
                        )}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedReports && paginatedReports.length > 0 ? (
                      paginatedReports.map((report, index) => (
                        <tr key={`${report.ref_txn_id}-${index}`}>
                          {/* 1. Reference Transaction ID */}
                          <td
                            className="copy-cell"
                            style={{ minWidth: "150px" }}
                          >
                            <span className="truncate-cell">
                              {report.ref_txn_id}
                            </span>
                            <CopyIcon textToCopy={report.ref_txn_id} />
                          </td>

                          {/* 2. Reference Message ID */}
                          <td
                            className="copy-cell"
                            style={{ minWidth: "150px" }}
                          >
                            <span className="truncate-cell">
                              {report.ref_message_id}
                            </span>
                            <CopyIcon textToCopy={report.ref_message_id} />
                          </td>

                          {/* 3. Message ID */}
                          <td
                            className="copy-cell"
                            style={{ minWidth: "150px" }}
                          >
                            <span className="truncate-cell">
                              {report.msg_id}
                            </span>
                            <CopyIcon textToCopy={report.msg_id} />
                          </td>

                          {/* 4. Buyer App ID */}
                          <td
                            className="copy-cell"
                            style={{ minWidth: "150px" }}
                          >
                            <span className="truncate-cell">
                              {report.buyer_app_id}
                            </span>
                            <CopyIcon textToCopy={report.buyer_app_id} />
                          </td>

                          {/* 5. Seller App ID */}
                          <td
                            className="copy-cell"
                            style={{ minWidth: "150px" }}
                          >
                            <span className="truncate-cell">
                              {report.seller_app_id}
                            </span>
                            <CopyIcon textToCopy={report.seller_app_id} />
                          </td>

                          {/* 6. Settlement ID */}
                          <td
                            className="copy-cell"
                            style={{ minWidth: "150px" }}
                          >
                            <span className="truncate-cell">
                              {report.settlement_id}
                            </span>
                            <CopyIcon textToCopy={report.settlement_id} />
                          </td>

                          {/* 7. Transaction ID */}
                          <td
                            className="copy-cell"
                            style={{ minWidth: "150px" }}
                          >
                            <span className="truncate-cell">
                              {report.txn_id}
                            </span>
                            <CopyIcon textToCopy={report.txn_id} />
                          </td>

                          <td style={{ minWidth: "150px" }}>
                            {formatDate(report.createdAt)}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={7}
                          className="text-center py-4 text-gray-500"
                        >
                          No Report Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </>
          )}

          {/* Pagination */}
          {totalOrderCount > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              startItem={startItem}
              endItem={endItem}
              totalItems={totalOrderCount}
              itemsPerPage={itemsPerPage}
              onItemsPerPageChange={handleItemsPerPageChange}
              onPageChange={goToPage}
              itemsPerPageOptions={itemsPerPageOptions}
            />
          )}
        </div>
      ) : (
        <UnAuthorized />
      )}
    </>
  );
};

export default Reports;
